module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ignore-box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticStyle: {
      "font": "4ex bold",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s((_vm.curArea + " Alert Ignore List").toUpperCase()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.dropdownFn
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          " + _vm._s(_vm.typeMap[_vm.activeType])), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ALL"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['ALL']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "IB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['IB']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "IB_SUB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['IB_SUB']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "SL"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['SL']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "SL_SUB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['SL_SUB']))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(_vm._s(_vm.multiLanguage.refresh))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(_vm._s(_vm.multiLanguage.add))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "margin-left": "50px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.node_id) + ":")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.trData,
      "border": "",
      "size": "small",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": _vm.multiLanguage.type
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "node_id",
      "label": _vm.multiLanguage.node_id
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": _vm.multiLanguage.operate
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(scope.row)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.delete))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.multiLanguage.add,
      "visible": _vm.dialogFormVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.type))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.addData.type),
      callback: function($$v) {
        _vm.$set(_vm.addData, "type", $$v)
      },
      expression: "addData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.typeMap['IB'],
      "value": "IB"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['IB_SUB'],
      "value": "IB_SUB"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['SL'],
      "value": "SL"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['SL_SUB'],
      "value": "SL_SUB"
    }
  })], 1)], 1)], 1), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.node_id))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-input', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.addData.node_id),
      callback: function($$v) {
        _vm.$set(_vm.addData, "node_id", $$v)
      },
      expression: "addData.node_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.cancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommit
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.submit))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69dbaf81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/AlertIgnore/AlertIgnore2.vue
// module id = 1124
// module chunks = 1